<template>
    <div>
        <b-row>
            <b-col>
                <div class="red" v-if="!canUpload">You have uploaded the maximum number of documents</div>
                <b-button v-b-modal="id +'modal-prevent-closing'"
                  variant="outline-primary" :disabled="!canUpload">Upload</b-button>
            </b-col>
        </b-row>
        
        <b-modal  hide-footer
            :id="id +'modal-prevent-closing'"
            ref="modal"
            title="Add Document"
            @show="resetModal"
            @hidden="resetModal"
            @ok="handleOk">

            <form ref="form" @submit.stop.prevent="handleSubmit">
                <form-group
                    :state="$v.file.$dirty ? !$v.file.$error : null"
                    label="File to Upload"
                    label-for="file-input"
                    :validator="$v.file">
                    <b-form-file
                        id="file-input"
                        v-model="file"
                        :state="$v.file.$dirty ? !$v.file.$error : null"
                        placeholder="Choose a file or drop it here..."
                        drop-placeholder="Drop file here..."
                    >
                    </b-form-file>
                </form-group>

                <b-button type="submit" variant="primary">Submit</b-button>
            </form>
        </b-modal>
    </div>
</template>

<script>
    import axios from "axios"
    import { required } from 'vuelidate/lib/validators'
    import fileType from '@/validators/fileType'
    import maxFileSize from '@/validators/maxFileSize';
    import ConfigService from "@/services/ConfigService";
    import moment from 'moment';

  export default {
    data() {
      return {
        file: null,
      }
    },
    props: {
      id: [String],
      applicationId: [String],
      documentTypeId: [String],
      canUpload: [Boolean],
    },
    validations: {
         file: { required, fileType: fileType(), maxFileSize: maxFileSize(), },
    },

    methods: {
      checkFormValidity() {
        const valid = this.$refs.form.checkValidity()
        return valid
      },
      resetModal() {
        this.name = null
      },

      handleOk(bvModalEvt) {
        bvModalEvt.preventDefault()
        this.handleSubmit()
      },

      handleSubmit() {
        this.$v.$touch()
        if (this.$v.$invalid || !this.canUpload) {
            return
        }

        const fd2 = new FormData()
        fd2.append('file', this.file)
        fd2.append('documentTypeId', this.documentTypeId)

        axios.post(ConfigService.getApiUrl() + `/api/applications/` + this.applicationId + '/documents', fd2)
          .then(response => {
              const fileData = {name: this.file.name, id: response.data, createDate: moment.now()}
              this.file = null

              this.$emit('document-added', fileData)

              let modalId = this.id + 'modal-prevent-closing';
              this.$nextTick(() => {
              this.$v.$reset()
              this.$bvModal.hide(modalId)
              this.showRootToast("Success", "Document has been uploaded and saved",   "success")
            })
          }).catch(err => {
            if (err.response) {
                let errorList = Object.values(err.response.data)
                this.showRootToast("Error", this.createErrorToast(errorList),
                    "danger")
            } else {
                this.showRootToast("Error", "Application was unable to connect.  Please try again later.",
                    "danger")
            }
          })
      },

      createErrorToast(errors) {
          const h = this.$createElement
          const errNodes = h(
              'div',
              [
                  h('p','The contents of your file contain invalid formatting.  Please use the Print to PDF function in your browser and attach the resulting file.'),
                  h('ul', [
                      errors.map(e => {
                          return h('li', {attrs:{class: 'circle-list ml-4'}}, e)
                      })
                  ])
              ]
          )
          return errNodes
      },
      showRootToast(title, message, type) {
          this.$root.$bvToast.toast(message, {
              title: title,
              toaster: 'b-toaster-top-center',
              solid: true,
              variant: type,
              appendToast: true,
              autoHideDelay: 5000,
          })
          this.toastFocus()
      },
      toastFocus() {
          setTimeout(() => {
              let elem = document.getElementsByClassName("toast")
              elem = elem[elem.length-1]
              elem.focus()
          }, 100)
      },
    }
  }
</script>